import { EventEmitter, Injectable } from '@angular/core';
import { ColunasSamuFormat } from '../commons/model/colunas-samu-format';
import { ColunasSamu } from '../commons/model/colunas-samu';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Utils } from './utils';

@Injectable()
export class UserUtil {

  apiPrincipal = environment.principal;

  private static _usuarioLogado = null;
  static sysdate: Date = new Date();
  private sysdateVal: Date;
  horaAtual = new EventEmitter<Date>();
  static onLoadParametros = new EventEmitter<any[]>();
  static cliqueSair: boolean;
  intervalSeconds;


  constructor(private http: HttpClient) {
    this.consultaSysdate();
  }

  static getParametro(idParametro: string, valorDefault: string = null): string | null {
    const valor = UserUtil.parametrosList[idParametro];
    return valor ? valor : valorDefault;
  }
  consultaSysdate() {
    this.http.get(this.apiPrincipal + '/api/sysdate').subscribe((response: any) => {
      this.sysdateVal = Utils.convertStringToDate(response.data[1]);
      this.atualizacaoData();
    },
    error => {
      this.atualizacaoData();
    });
  }

  atualizacaoData() {
    if (this.intervalSeconds) {
      clearInterval(this.intervalSeconds);
    }
    this.horaAtual.emit(this.sysdateVal);
    this.intervalSeconds = setInterval(tick => {
      this.sysdateVal = new Date(this.sysdateVal.getTime() + 1000);
      this.horaAtual.emit(this.sysdateVal);
    }, 1000);
    setTimeout(()=>{
      this.consultaSysdate();
    }, 5000);
  }

  set sysdateUser(value) {
    if(value) {
      this.sysdateVal = value;
    }
  }

  get sysdateUser(): Date {
    return this.sysdateVal;
  }

  static set usuarioLogado(value) {
    UserUtil._usuarioLogado = value;
    this.cliqueSair = false;
  }
  static get usuarioLogado() {
    if (UserUtil._usuarioLogado == null) {
      UserUtil._usuarioLogado = JSON.parse(localStorage.getItem('currentUser'));
    }
    return UserUtil._usuarioLogado;
  }
  static _parametrosList: any[] = [];
  static set parametrosList(value) {
    UserUtil._parametrosList = value;
  }
  static get parametrosList() {
    if (UserUtil._parametrosList == null || UserUtil._parametrosList.length === 0) {
      UserUtil._parametrosList = JSON.parse(localStorage.getItem('parametros'));
    }
    return UserUtil._parametrosList;
  }

  static retirarCaracteresEspeciais(text: string): string {
    if (text != null) {
      // acento agudo
      text = text.toUpperCase();
      text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'A');
      text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'E');
      text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'I');
      text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'O');
      text = text.replace(new RegExp('[ÚÙÛÜ]', 'gi'), 'U');
      text = text.replace(new RegExp('[Ç]', 'gi'), 'C');
      text = text.replace('´', '');
      text = text.replace('^', '');
      text = text.replace('~', '');
      text = text.replace('¨', '');
      text = text.replace('`', '');
    }
    return text;
  }

/**
   * Autor: David Coelho
   *
   * Esta função separa o objeto do campo idField da ColunasSamu, para uso nas p-tables.
   * @param {ColunasSamu[]} colunas Colunas da tabela BOP_COLUNAS_SAMU.
   * @param {boolean} log Ativar o log do retorno.
   *
   * Ex.: {{OBJETO/LISTA[col.prefixo][col.campo]}} quando tiver um objeto no idField(hospital.dsHospital), e
   * {{OBJETO/LISTA[col.campo]}} quando não houver um objeto no idField(dsHospital).
  */
 static splitPropriedadeDeObjetos(colunas: ColunasSamu[], log?: boolean): ColunasSamuFormat[] {
  let stringSplit;
  let coluna: ColunasSamuFormat = new ColunasSamuFormat();
  const lista: ColunasSamuFormat[] = [];

  for (let i = 0, len = colunas.length ; i < len; i++) {
    coluna.width = colunas[i].nrWidth;
    coluna.label = colunas[i].vlLabel;

    if (colunas[i].idField.includes('.')) {
      stringSplit = colunas[i].idField.split('.');
      coluna.prefixo = stringSplit[0];
      coluna.campo = stringSplit[1];
    } else {
      coluna.prefixo = undefined;
      coluna.campo = colunas[i].idField;
    }
    lista.push(coluna);
    coluna = new ColunasSamuFormat();
  }
  if (log) {
  //  console.log('splitPropriedadeDeObjetos retorno');
  //  console.log(lista);
  }
  return lista;
}

  /**
   * Autor: David Coelho
   *
   * Esta função verifica qual o tipo da data, e o retorna como um objeto Date.
   * @param {any} data
  */
 static verificarTipoData(data: any) {
  if (typeof data === 'number') {
    return new Date(data);
  } else if (typeof data === 'string') {
    return new Date(data);
  } else {
    return data;
  }
}

 static abrirPopup(link: any) {
   if (global.eval('verificarJanelaAberta()')) {
     // JA EXECUTADO NA TELA ANTERIOR
     //global.eval('refreshMapa' + '("' + link + '", "' + UserUtil.usuarioLogado.login + '")');
   } else {
     global.eval('abrirPopup' + '("' + link + '", "' + UserUtil.usuarioLogado.login + '")');
   }
 }

}





// WEBPACK FOOTER //
// ./src/app/core/user-util.ts